
export function subscribeAll(observables, compute) {
  const subscriptions = new Array(observables.length);
  const dataStores = new Array(observables.length);

  observables.forEach((observable, index) => {
    const subscription = observable.subscribe((data) => {
      dataStores[index] = data;
      compute(dataStores);
    });

    subscriptions[index] = subscription;
  });

  function unsubscribe() {
    subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  return {
    unsubscribe,
  };
}
